import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";

import moment from "moment";

import { EmailLogContext } from "components/email-log/EmailLogContext";
import { Button } from "primereact/button";

export const EmailLogEditor = () => {
    const toast = useRef(null);
    const { t } = useTranslation(["email-log", "common"]);

    const emailLogContext = useContext(EmailLogContext);
    const { emailLog, setEmailLog, emailLogDialog, setEmailLogDialog } = emailLogContext;

    const logStatus = [
        { label: t("not_send"), value: "NOT_SEND" },
        { label: t("sent_success"), value: "SENT_SUCCESS" },
        { label: t("sent_failure"), value: "SENT_FAILURE" },
    ];

    const hideDialog = () => {
        setEmailLogDialog(false);
    };

    const formatDateInput = (data) => {
        if (data) {
            const year = data?.substr(0, 4);
            const month = data?.substr(5, 2);
            const day = data?.substr(8, 2);
            const hour = data?.substr(11, 2);
            const minute = data?.substr(14, 2);
            const second = data?.substr(17, 2);

            return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
        }
        return null;
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog visible={emailLogDialog} style={{ width: "60%" }} header={t("emailLog.titleDetail").toLocaleUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* email */}
                                <div className="field col-12 md:col-6">
                                    <label htmlFor="email">{t("email")}</label>
                                    <InputText id="email" value={emailLog?.email} readOnly />
                                </div>
                                {/* tiêu ĐỀ */}
                                <div className="field col-12 md:col-6">
                                    <label htmlFor="title">{t("title")}</label>
                                    <InputText id="title" value={emailLog?.title} readOnly />
                                </div>
                            </div>
                            <div className="grid">
                                {/* trạng thái */}
                                <div className="field col-12 md:col-6">
                                    <label htmlFor="status">{t("status")}</label>
                                    <InputText id="status" value={logStatus.find((g) => g.value === emailLog?.status)?.label} readOnly />
                                </div>

                                {/* ngày gửi */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdDate">{t("createdDate")}</label>
                                    <InputText id="createdDate" value={formatDateInput(emailLog?.createdDate)} readOnly />
                                </div>
                                {/* ngày cập nhật */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="modifiedDate">{t("modifiedDate", { ns: "common" })}</label>
                                    <InputText id="modifiedDate" value={formatDateInput(emailLog?.updatedDate)} readOnly />
                                </div>
                            </div>
                            <div className="grid">
                                {/* nội dung gửi */}
                                <div className="field col-12 ">
                                    <label htmlFor="content">{t("content")}</label>
                                    <Editor id="content" showHeader={false} style={{ height: "300px" }} value={emailLog?.content} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
